import * as packageJson from '../../package.json';

export const environment = {
  dev: true,
  staging: false,
  production: false,
  environmentName: 'development',
  isLocalDevelopment: false,
  cognito: {
    userPoolId: 'eu-west-1_NE0sc3gmd',
    userPoolClientId: '3vdb3qjem9erhgdll0csaoc9df',
    token: '',
  },
  appVersion: packageJson.version + '-local',
  basePath: 'https://dev.signup.clinicalbrain.com',
};
